import axios from "axios";
import { apiURL } from "../config/default";

import { alert } from "./alert";
import setAuthHeader from "../utils/setAuthHeader";

export const create = ({
  orderCommissionPercentage,
  withdrawalLimitDays,
  minimumWithdrawalLimit,
  maximumWithdrawalLimit,
  processingFeePercentage
}) => async dispatch => {
  const _config = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  const body = JSON.stringify({
    orderCommissionPercentage,
    withdrawalLimitDays,
    minimumWithdrawalLimit,
    maximumWithdrawalLimit,
    processingFeePercentage
  });

  try {
    const res = await axios.post(
      `${apiURL}admin/create-payment-setting`,
      body,
      _config
    );
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach(error => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};

export const retreive = () => async dispatch => {
  const _config = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(`${apiURL}admin/get-payment-setting`, _config);
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach(error => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
